import React, { useState, useEffect } from "react";
import axios from "axios";

const BannerSection = () => {
  const [bannerData, setBannerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // State for the video player
  const [currentVideoId, setCurrentVideoId] = useState("");

  // Fetch Data
  useEffect(() => {
    const fetchBannerData = async () => {
      try {
        const res = await axios.get("https://all-in-one-youtube-cc51e2f64b53.herokuapp.com/api/banner-section");
        setBannerData(res.data.data);
        // Set initial video ID from API
        if (res.data.data?.mainVideoId) {
          setCurrentVideoId(res.data.data.mainVideoId);
        }
      } catch (err) {
        console.error("Failed to fetch banner data", err);
        setError("Failed to load banner.");
      } finally {
        setLoading(false);
      }
    };
    fetchBannerData();
  }, []);

  // Handlers
  const handleVideoSelect = (id) => {
    setCurrentVideoId(id);
    document
      .getElementById("video-player-container")
      .scrollIntoView({ behavior: "smooth" });
  };

  const handleWatchNow = (e) => {
    e.preventDefault();
    document
      .getElementById("video-player-container")
      .scrollIntoView({ behavior: "smooth" });
  };

  if (loading) return <div className="text-center py-5 text-white"></div>;
  if (error || !bannerData) return null;

  return (
    <>
      {/* --- Dynamic Banner Section --- */}
      <section
        className="banner-section"
        style={{
          backgroundImage: `url(${bannerData.backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          paddingTop: "150px",
        }}
      >
        <div className="container">
          <div className="">
            <div className="banner-content text-center pt-5">
              {/* Dynamic Subtitle */}
              <h4 className="fw-normal theme-color mb-4">
                {bannerData.subTitle}
              </h4>

              {/* Dynamic Main Title */}
              <h1 className="text-white fw-bold mb-4">
                {bannerData.mainTitle}
              </h1>

              {/* Dynamic Description */}
              <p style={{ color: "#fff" }}>
                {bannerData.description}
              </p>

              {/* Watch Now Button */}
              {/* <div className="mb-5">
                 <a 
                    href="#video-player-container" 
                    onClick={handleWatchNow}
                    className="btn btn-primary px-4 py-2 rounded-pill"
                 >
                    Watch Demo
                 </a>
              </div> */}

              {/* Dynamic Video Player */}
              {/* <section id="video-player-container" className="py-5">
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-lg-10">
                      <div
                        className="video-wrapper position-relative"
                        style={{
                          borderRadius: "10px",
                          overflow: "hidden",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
                        }}
                      >
                        <div
                          style={{
                            padding: "56.25% 0 0 0",
                            position: "relative",
                          }}
                        >
                          <iframe
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                            }}
                            src={`https://www.youtube.com/embed/${currentVideoId}?rel=0&modestbranding=1&iv_load_policy=3`}
                            title="YouTube Video Player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section> */}
            </div>

            {/* Dynamic Featured Videos (Thumbnails) */}
            {/* <div className="banner-thumb d-flex flex-wrap justify-content-center justify-content-lg-center gap-3 mt-5">
              {bannerData.featuredVideos && bannerData.featuredVideos.length > 0 ? (
                bannerData.featuredVideos.map((video, index) => (
                  <div 
                    key={index} 
                    className="cursor-pointer"
                    onClick={() => handleVideoSelect(video.id)}
                    style={{ cursor: "pointer", width: "150px", transition: "transform 0.2s" }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                    onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                  >
                    <img 
                      src={video.thumbnail || `https://img.youtube.com/vi/${video.id}/hqdefault.jpg`} 
                      alt={video.title}
                      className="img-fluid rounded shadow-sm"
                      style={{ border: currentVideoId === video.id ? "3px solid #007bff" : "none" }}
                    />
                    <p className="text-white small text-center mt-2 text-truncate">{video.title}</p>
                  </div>
                ))
              ) : (
                <p className="text-white-50">No featured videos added.</p>
              )}
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default BannerSection;